import {useLessonManager} from "../../../hooks/useLessonManager";
import {useLessonOccurrenceManager} from "../../../hooks/useLessonOccurrenceManager";
import {useHolidayManager} from "../../../hooks/useHolidayManager";
import moment from "moment/moment";
import {LessonWithOccurrenceIdAndDate} from "../../../model/LessonWithOccurrenceIdAndDate";
import {parseByDate} from "../../../utils/timetable";
import {Timetable} from "../../../types/Timetable";
import {useSubjectManager} from "../../../hooks/useSubjectManager";

export const useTimetableLayoutManager = (
    selectedPlannerId: string,
    selectedTimetable: Timetable | undefined,
    daysOfWeek: moment.Moment[]
) => {
    const selectedTimetableId = selectedTimetable?.id ?? ""

    const {subjects} = useSubjectManager({plannerId: selectedPlannerId})
    const {lessons} = useLessonManager({plannerId: selectedPlannerId, timetableId: selectedTimetableId});
    const {lessonOccurrences} = useLessonOccurrenceManager({plannerId: selectedPlannerId, timetableId: selectedTimetableId});
    const {holidays} = useHolidayManager({plannerId: selectedPlannerId});

    let lessonsByDate: Map<moment.Moment, LessonWithOccurrenceIdAndDate[]> = new Map();
    if (selectedTimetable) {
        daysOfWeek.forEach(dayOfWeek => {
            lessonsByDate.set(dayOfWeek, parseByDate(
                lessons,
                lessonOccurrences,
                subjects,
                dayOfWeek.clone(),
                selectedTimetable,
                holidays,
                moment().startOf('week')
            ))
        });
    }

    return {
        lessons,
        lessonOccurrences,
        lessonsByDate,
        holidays
    }
}